// Template
NP.template = {
	// 외부 요청 친구 상태 return
	ex_btnFriend : function( data ){
		var markup = "";

		switch ( data ){
			case 'sentProposals' : markup = 'NC친구신청중'; break;
			case 'friend' : markup = 'NC친구'; break;
		}

		return markup;
	},

	// 외부 요청 구독 상태 return
	ex_btnFollow : function( data ){
		var markup = "";
		switch ( data ){
			case 'following' : markup = '구독중'; break;
		}

		return markup;
	},


	// 함께 아는 친구 layer outline
	withFriendLayer : function( data ){
		var markup = '';

		markup += '<section id="modallessTogether" class="ly_modalless">';
		markup += '<div class="wrap_together">';
		markup += '</div></section>';

		return markup;
	},

	// 함께 아는 친구 layer content
	withFriendLayerCont : function( data ){
		var markup = '';

		markup += '<header><h5><strong>' + data.userName + '</strong>님과 함께 아는 친구 ' + data.withFriend.length + '명</h5><a class="js_close close">닫기</a></header>';
		markup += '<div class="ul_list"><ul>';
		for( i=0 ; i<data.withFriend.length ; i++) {
			markup += '<li><a href="' + NP.prflUri( data.withFriend[i].playncAcctId ) + '"><img src="' + NP.sfile( data.withFriend[i].playncAcctId ) + '" class="thumb_profile" alt=""></a>';
			markup += ' <a class="nickname" href="' + NP.prflUri( data.withFriend[i].playncAcctId ) + '">' + data.withFriend[i].userName + '</a></li>';
		}
		markup += '</ul></div>';

		return markup;
	},

	// 미니프로필 layer outline
	miniProfileLayer : function( data ){
		var markup = '';

		markup += '<section id="' + data + '">';
		markup += '<div class="txt_error"></div>';
		markup += '<div class="loading"><img src="' + NP.STATIC_URL + '/sandbox/common/loading_type1.gif" alt="로딩중 입니다."></div>';
		markup += '</section>';

		return markup;
	},

	// 미니프로필 layer content
	miniProfileLayerCont : function( data ){
		/*
		data = {
			all : ,
			playncAcctId : text,
			userName : text,
			mobileUser : boolean,
			birthday : text,
			sex : text,
			intro : text,
			withFriendCount : number,
			withFriend : [
				{
					playncAcctId : text,
					userName : text
				}
			],
			friendCount : number,
			friendRelation : sentProposals | friend
			followRelation : following | followee
		}
		*/
		var markup = '';

		markup += '<div class="ly_miniProfile"><dl>';
		markup += '<dt><a class="nickname" href="' + NP.prflUri( data.playncAcctId ) + '">' + data.userName + '</a> ';

		if( NP.Util.isSandbox() && data.mobileUser ){
			markup += '<a class="ncmsn" title="NC메신저 이용 중" onclick="modal.show( jQuery( \'#modalGuideNcmsn\' ) )"><span>NC메신저 이용 중</span></a>';
		}

		markup += '</dt><dd class="info"><a href="' + NP.prflUri( data.playncAcctId ) + '"><img alt="" class="thumb" src="' + NP.sfile( data.playncAcctId ) + '"/></a><p><span class="birth">' + data.birthday + '</span> <span class="sex">' + data.sex + '</span></p></dd>';
		if( data.intro ) markup += '<dd class="intro">' + data.intro + '</dd>';
		if( 0 < data.withFriendCount ) {
			markup += '<dd class="togetherThumb">';
			for( i=0 ; i<data.withFriend.length; i++){
				markup += '<a href="' + NP.prflUri( data.withFriend[i].playncAcctId ) + '"><img src="' + NP.sfile( data.withFriend[i].playncAcctId ) + '" alt="" title="' + data.withFriend[i].userName + '" class="thumb" /></a> ';
			}
			markup += '</dd>';
		}

		if ( data.withFriendCount!='' || data.friendCount!='' ) {
			markup += '<dd class="count">';
			if( 0 < data.withFriendCount ) markup += '함께 아는 친구 <a class="js_withFriendLayer" data-np=\'{"id":"' + data.playncAcctId + '","nm":"' + data.userName + '"}\'>' + data.withFriendCount + '명</a>';
			if( 0<data.withFriendCount && 0<data.friendCount ) markup += ' / ';
			if( 0 < data.friendCount ) markup += 'NC친구 ' + data.friendCount + '명';
			markup += '</dd>';
		}
		markup += '</dl>';


		if( NP.Util.isSandbox() ){
			markup += '<div class="wrap_button">' + NP.Button.mProfile( data.all ) + '</div>';
		} else {
			if( NP.dt.v !== '' && NP.dt.v === data.playncAcctId ){
				markup += '<div class="wrap_button"><a href="' + NP.prflUri( data.playncAcctId ) + '/my/profile/modify" class="btn_connect confirm">프로필 수정</a></div>';
			} else if( NP.template.ex_btnFriend( data.friendRelation )!="" || NP.template.ex_btnFollow( data.followRelation )!="" ){
				markup += '<div class="wrap_button"><p class="state">';
				markup += NP.template.ex_btnFriend( data.friendRelation );
				if( NP.template.ex_btnFriend( data.friendRelation )!="" && NP.template.ex_btnFollow( data.followRelation )!="" ) {
					markup += ' <span class="bar">|</span> ';
				}
				markup += NP.template.ex_btnFollow( data.followRelation );
				markup += '</p></div>';
			}
		}

		markup += '</div>';

		return markup;
	}

}